<template>
  <div class="skeleton-shimmer rounded" :class="classes" :style="style"></div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    width: { type: String, default: '100%' },
    height: { type: String, default: '14px' },
    rounded: { type: String, default: '' },
    className: { type: String, default: '' }
  },
  computed: {
    style () {
      return {
        width: this.width,
        height: this.height,
        borderRadius: this.rounded || undefined
      }
    },
    classes () {
      return this.className
    }
  }
}
</script>

<style>
.skeleton-shimmer {
  background: linear-gradient(90deg, #e2e4ed 25%, #d6d8e3 50%, #e2e4ed 75%);
  background-size: 200% 100%;
  animation: skeleton-pulse 1.5s ease-in-out infinite;
}

@keyframes skeleton-pulse {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
